import { useState, useEffect } from "react"
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Card,
  CardContent,
  CardMedia,
  TextField,
  Container,
  Grid,
  Avatar,
  useMediaQuery,
  useTheme,
  Divider,
  Fab,
  Zoom,
} from "@mui/material"
import { motion } from "framer-motion"
import MenuIcon from "@mui/icons-material/Menu"
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"
import FacebookIcon from "@mui/icons-material/Facebook"
import TwitterIcon from "@mui/icons-material/Twitter"
import LinkedInIcon from "@mui/icons-material/LinkedIn"
import InstagramIcon from "@mui/icons-material/Instagram"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import EmailIcon from "@mui/icons-material/Email"
import PhoneIcon from "@mui/icons-material/Phone"
import { keyframes } from "@emotion/react"
import swal from "sweetalert";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {  AnimatePresence } from "framer-motion";

// import image14 from './landpageimage1/Parag.jpg';
import axios from "axios";
import Swal from "sweetalert2";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"
import { useNavigate } from "react-router-dom"; // Import useNavigate
import {  Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
// Import images
// Note: In a real project, you would need to have these images in your project
import slide1 from "../src/images/tdtlbranding.png"
import one  from "../src/images/one.webp"
import two from "../src/images/two.webp"
import three from "../src/images/three.webp"
import image25 from "../src/landpageimage1/garghi.jpeg"
import image9 from './landpageimage1/Santosh Pardeshi1.png.jpg'
import image10 from './landpageimage1/deepabadveorginal.png';
import image11 from './landpageimage1/Dr. Prashant Iyer.jpg';
import image12 from './landpageimage1/canewsarvesh.png';
import image13 from './landpageimage1/krishnavirma.jpg';
import image14 from './landpageimage1/Parag.jpg';
import dada from "../src/images/Image (3).jpeg"
import image2 from "./landpageimage1/mrdegonkardestination.jpg"
import image3 from "./landpageimage1/missdeogankar.png"
import image4 from "./landpageimage1/amitsir.jpg"
import CloseIcon from "@mui/icons-material/Close";
import logo1 from './landpageimage1/destinationlogo.png';
import logo2 from './landpageimage1/tdtllogo3.png';
import image5 from './landpageimage1/Manasithakur.jpeg';
import image6 from './landpageimage1/vikasapte.jpg';
import image7 from './landpageimage1/shotri.jpg';
import image8 from './landpageimage1/deepabadve.jpg';
import bg from "./landpageimage1/mitwpu.jpg";
import slide2 from "./landpageimage1/working2.jpg";
import slide3 from "./landpageimage1/mitwpuslide.jpg"; 
import Logo3 from './landpageimage1/mitsyum1.png'
import Logo4 from './landpageimage1/startuplogo.png';
import Logo5 from './landpageimage1/logo5.jpeg';
import Logo6 from './landpageimage1/Logo6.jpeg'
import logo7 from './landpageimage1/logo7.jpeg'
import logo8 from './landpageimage1/logo8.jpeg'
import logo9 from './landpageimage1/logo9.jpeg'
import logo10 from './landpageimage1/logo10.png'
import logo11 from './landpageimage1/logo11.jpeg'
import logo12 from './logos/l1.png'
import logo13 from './logos/l2.png'
import logo14 from './logos/l3.jpeg'
import logo15 from './logos/l4.jpeg'
import logo16 from './logos/l5.jpeg'
import logo17 from './logos/l6.jpg'
import logo18 from './logos/l7.jpeg'


import image15 from './landpageimage1/prasad.jpg';
import image16 from './landpageimage1/anantmulay1.jpg';
import image17 from './landpageimage1/nikhilsir.jpg';
import image18 from './landpageimage1/AshishRaut.jpg';
import image19 from './landpageimage1/prachimam.jpg';
import image20 from './landpageimage1/Sunita Chitnis.jpg';
import image21 from './landpageimage1/Harshda.jpeg';
import image22 from './landpageimage1/atharava.jpg';
import image23 from './landpageimage1/neelimaa.jpg';

const Navbar=()=>{
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const navItems = ["Home", "About", "Industries",  "Contact"];
  const handleOpen = () => setOpen(true);



  // Close popup

  const handleClose = () => setOpen(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleDrawer = (state) => () => {
    setOpen(state);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setOpen(false);
  };

  return (
    <>
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "#ffffff",
        color: "orange",
        boxShadow: scrolled ? "0 4px 20px rgba(0, 0, 0, 0.1)" : "none",
        transition: "all 0.3s ease-in-out",
      }}
    >
      <Toolbar>
        {/* Logos Side by Side */}
        <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <img src={logo1} alt="Logo 1" style={{ height: "50px", width: "auto" }} />
            <img src={logo2} alt="Logo 2" style={{ height: "50px", width: "auto" }} />
          </Box>
        </motion.div>

        <Box sx={{ flexGrow: 1 }} />

        {/* Navigation Items */}
        <Box sx={{ display: { xs: "none", md: "flex" } }}>
          {navItems.map((item, index) => (
            <motion.div key={item} initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: index * 0.1 }}>
              <Button
                onClick={() => scrollToSection(item.toLowerCase())}
                sx={{
                  color: "orange",
                  fontWeight: "bold",
                  mx: 1,
                  position: "relative",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: 0,
                    left: "50%",
                    width: "0%",
                    height: "2px",
                    backgroundColor: "orange",
                    transition: "all 0.3s ease",
                    transform: "translateX(-50%)",
                  },
                  "&:hover::after": {
                    width: "80%",
                  },
                }}
              >
                {item}
              </Button>
            </motion.div>
          ))}
          <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5, delay: 0.5 }}>
          
          </motion.div>
        </Box>

        {/* Mobile Menu Button */}
        <IconButton edge="end" color="inherit" aria-label="menu" sx={{ display: { xs: "block", md: "none" } }} onClick={toggleDrawer(true)}>
          <MenuIcon />
        </IconButton>

        {/* Mobile Drawer */}
        <Drawer
          anchor="right"
          open={open}
          onClose={toggleDrawer(false)}
          PaperProps={{
            sx: {
              width: 250,
              background: "linear-gradient(135deg, #fff 0%, #f9f9f9 100%)",
              boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
            },
          }}
        >
          <Box sx={{ p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <img src={logo2} alt="Logo 2" style={{ height: "40px", width: "auto" }} />
              <img src={logo1} alt="Logo 1" style={{ height: "40px", width: "auto" }} />
              
            </Box>
            <IconButton onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </Box>


          <Divider sx={{ mb: 2 }} />
          <List>
            {navItems.map((text) => (
              <ListItem
                button
                key={text}
                onClick={() => scrollToSection(text.toLowerCase())}
                sx={{
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "rgba(255, 152, 0, 0.1)",
                    transform: "translateX(5px)",
                  },
                }}
              >
                <ListItemText primary={text} primaryTypographyProps={{ sx: { color: "#333", fontWeight: "medium" } }} />
              </ListItem>
            ))}
          </List>
 
        </Drawer>
      </Toolbar>
    </AppBar>

    </>

  );
}




const slides = [slide1, slide2, slide3];


// const HeroSection = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const navigate = useNavigate();
//   const [open, setOpen] = useState(false);

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   return (
//     <Box
//       id="home"
//       sx={{
//         height: "100vh",
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//         alignItems: "center",
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* Carousel Section */}
//       <Carousel autoPlay infiniteLoop interval={3000} showThumbs={false} showStatus={false} showArrows={false} showIndicators={false} stopOnHover={false}>
//         {slides.map((slide, index) => (
//           <div key={index}>
//             <img
//               src={slide}
//               alt={`Slide ${index + 1}`}
//               style={{
//                 width: "100%",
//                 height: "100vh",
//                 objectFit: "cover",
//                 filter: "brightness(40%)",
//               }}
//             />
//           </div>
//         ))}
//       </Carousel>

//       {/* Content Box (Centered) */}
//       <Box
//         sx={{
//           position: "absolute",
//           top: "65%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           textAlign: "center",
//           backdropFilter: "blur(10px)",
//           background: "rgba(0, 0, 0, 0.3)",
//           padding: "2.5rem",
//           borderRadius: "20px",
//           boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
//           maxWidth: "800px",
//           width: "90%",
//         }}
//       >
//         <Typography
//           variant={isMobile ? "h4" : "h3"}
//           sx={{
//             fontWeight: "bold",
//             color: "orange",
//             textShadow: "2px 2px 10px rgba(0,0,0,0.5)",
//             letterSpacing: "1px",
//           }}
//         >
//           Pune's Startup Expo 2025
//         </Typography>

//         <Typography
//           variant={isMobile ? "h6" : "h5"}
//           sx={{
//             mt: 2,
//             color: "white",
//             fontWeight: 500,
//             textShadow: "1px 1px 5px rgba(0,0,0,0.3)",
//             lineHeight: 1.5,
//           }}
//         >
//           Connect, Innovate, Accelerate
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             mt: 2,
//             color: "rgba(255, 255, 255, 0.9)",
//             maxWidth: "600px",
//             mx: "auto",
//             lineHeight: 1.6,
//           }}
//         >
//           Join us on April 10th, 2025 at MIT WPU for a day of innovation, networking, and growth opportunities with the
//           brightest minds in the startup ecosystem.
//         </Typography>

//         {/* Register Button */}
//         <Button
//           variant="contained"
//           sx={{
//             mt: 3,
//             backgroundColor: "#FF7F00",
//             color: "white",
//             fontSize: isMobile ? "0.9rem" : "1.1rem",
//             padding: isMobile ? "0.6rem 1.5rem" : "0.75rem 2rem",
//             borderRadius: "30px",
//             transition: "all 0.3s ease-in-out",
//             boxShadow: "0px 5px 15px rgba(255, 127, 0, 0.5)",
//             "&:hover": {
//               backgroundColor: "#FF9500",
//               boxShadow: "0px 10px 25px rgba(255, 127, 0, 0.7)",
//               transform: "translateY(-3px)",
//             },
//           }}
//           onClick={handleOpen}
//         >
//           Register Now
//         </Button>
//       </Box>

//       {/* Popup Modal */}
//       <Dialog
//       open={open}
//       onClose={handleClose}
//       PaperProps={{
//         sx: {
//           borderRadius: "15px",
//           padding: "1.5rem",
//           background: "linear-gradient(135deg, #fff7e6, #ffdab9)",
//           width: "90%",
//           maxWidth: "500px",
//         },
//       }}
// >
// <IconButton
//         onClick={handleClose}
//         sx={{ position: "absolute", top: "10px", right: "10px", color: "#FF7F00" }}
// >
// <CloseIcon />
// </IconButton>
 
//       <DialogTitle
//         sx={{
//           color: "#FF7F00",
//           textAlign: "center",
//           fontWeight: "bold",
//           fontSize: { xs: "1.2rem", sm: "1.5rem" },
//         }}
// >
//         Select Your Role
// </DialogTitle>
 
//       <DialogContent>
// <Box
//           sx={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             gap: "1rem",
//             padding: "1rem",
//             flexDirection: { xs: "column", sm: "row" },
//           }}
// >
//           {/* Student Button */}
// <Button
//             variant="contained"
//             sx={{
//               backgroundColor: "#FF7F00",
//               color: "white",
//               fontWeight: "bold",
//               fontSize: "1rem",
//               padding: "0.8rem 1.5rem",
//               borderRadius: "30px",
//               transition: "all 0.3s ease-in-out",
//               width: { xs: "100%", sm: "48%" },
//               "&:hover": { backgroundColor: "#FF9500" },
//             }}
//             onClick={() => navigate("/StudentRegister")}
// >
//             Students & Budding Entrepreneurs
// </Button>
 
//           {/* Investor Button */}
// <Button
//             variant="contained"
//             sx={{
//               backgroundColor: "white",
//               color: "#FF7F00",
//               fontWeight: "bold",
//               fontSize: "1rem",
//               padding: "0.8rem 1.5rem",
//               borderRadius: "30px",
//               transition: "all 0.3s ease-in-out",
//               border: "2px solid #FF7F00",
//               width: { xs: "100%", sm: "48%" },
//               "&:hover": { backgroundColor: "#FF7F00", color: "white" },
//             }}
//             onClick={() => navigate("/invesRegis")}
// >
//             Angel Investors & Mentors
// </Button>
// </Box>
// </DialogContent>
// </Dialog>
      
//       <motion.div

//         initial={{ opacity: 0 }}

//         animate={{ opacity: 1 }}

//         transition={{ delay: 2.5, duration: 1 }}

//         style={{

//           position: "absolute",

//           bottom: "30px",

//           left: "50%",

//           transform: "translateX(-50%)",

//         }}

//       >

//         <motion.div animate={{ y: [0, 10, 0] }} transition={{ repeat: Number.POSITIVE_INFINITY, duration: 1.5 }}>

//           <Typography

//             variant="body2"

//             sx={{

//               color: "white",

//               textAlign: "center",

//               textShadow: "1px 1px 3px rgba(0,0,0,0.5)",

//             }}

//           >

//             Scroll Down

//           </Typography>

//           <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>

//             <Box

//               sx={{

//                 width: "30px",

//                 height: "50px",

//                 border: "2px solid white",

//                 borderRadius: "20px",

//                 position: "relative",

//                 "&::before": {

//                   content: '""',

//                   position: "absolute",

//                   top: "8px",

//                   left: "50%",

//                   width: "6px",

//                   height: "6px",

//                   backgroundColor: "white",

//                   borderRadius: "50%",

//                   transform: "translateX(-50%)",

//                   animation: "scrollDown 1.5s infinite",

//                 },

//                 "@keyframes scrollDown": {

//                   "0%": { top: "8px", opacity: 1 },

//                   "100%": { top: "32px", opacity: 0 },

//                 },

//               }}

//             />

//           </Box>

//         </motion.div>

//       </motion.div>

//     </Box>
//   );
// }

const HeroSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const handleAttendOpen = () => setAttendOpen(true);
  const handleAttendClose = () => setAttendOpen(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [attendOpen, setAttendOpen] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", phone_number: "" });


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const { name, email, phone_number } = formData;
  
    if (!name || !email || !phone_number) {
      Swal.fire("Error", "All fields are required.", "error");
      return;
    }
  
    const payload = {
      ...formData,
      message: "I am visiting the event",
    };
  
    try {
      const response = await axios.post(
        "https://puneexpobackend.tdtlworld.com/contact/attend/",
        payload
      );
      if (response.status === 201) {
        Swal.fire("Success", "Attendance accepted successfully!", "success");
        handleAttendClose();
        setFormData({ name: "", email: "", phone_number: "" });
      }
    } catch (error) {
      Swal.fire("Error", "Please check network and required fields", "error");
    }
  };
  return (
    <Box
      id="home"
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Carousel Section */}
      <Carousel autoPlay infiniteLoop interval={3000} showThumbs={false} showStatus={false} showArrows={false} showIndicators={false} stopOnHover={false}>
        {slides.map((slide, index) => (
          <div key={index}>
            <img
              src={slide}
              alt={`Slide ${index + 1}`}
              style={{
                width: "100%",
                height: "100vh",
                objectFit: "cover",
                filter: "brightness(40%)",
              }}
            />
          </div>
        ))}
      </Carousel>

      {/* Content Box (Centered) */}
      <Box
        sx={{
          position: "absolute",
          top: "65%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          backdropFilter: "blur(10px)",
          background: "rgba(0, 0, 0, 0.3)",
          padding: "2.5rem",
          borderRadius: "20px",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
          maxWidth: "800px",
          width: "90%",
        }}
      >
        <Typography
          variant={isMobile ? "h4" : "h3"}
          sx={{
            fontWeight: "bold",
            color: "orange",
            textShadow: "2px 2px 10px rgba(0,0,0,0.5)",
            letterSpacing: "1px",
          }}
        >
          Pune Startup Expo 2025
        </Typography>

        <Typography
          variant={isMobile ? "h6" : "h5"}
          sx={{
            mt: 2,
            color: "white",
            fontWeight: 500,
            textShadow: "1px 1px 5px rgba(0,0,0,0.3)",
            lineHeight: 1.5,
          }}
        >
          Connect, Innovate, Accelerate
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            color: "rgba(255, 255, 255, 0.9)",
            maxWidth: "600px",
            mx: "auto",
            lineHeight: 1.6,
          }}
        >
          Join us on April 10th, 2025 at MIT WPU for a day of innovation, networking, and growth opportunities with the
          brightest minds in the startup ecosystem.
        </Typography>

        {/* Buttons Container */}
        <Box
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "center",
            gap: "1.5rem",
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          {/* Register Button */}
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#FF7F00",
              color: "white",
              fontSize: isMobile ? "0.9rem" : "1.1rem",
              padding: isMobile ? "0.6rem 1.5rem" : "0.75rem 2rem",
              borderRadius: "30px",
              transition: "all 0.3s ease-in-out",
              boxShadow: "0px 5px 15px rgba(255, 127, 0, 0.5)",
              "&:hover": {
                backgroundColor: "#FF9500",
                boxShadow: "0px 10px 25px rgba(255, 127, 0, 0.7)",
                transform: "translateY(-3px)",
              },
            }}
            onClick={handleOpen}
          >
            Participate Now
          </Button>

          {/* Visitor Button */}
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#FF7F00",
              color: "white",
              borderRadius: "30px",
              boxShadow: "0px 5px 15px rgba(255, 127, 0, 0.5)",
              fontSize: "1.2rem",
              padding: "12px 24px",
              "&:hover": {
                backgroundColor: "white",
                color: "#FF7F00",
                boxShadow: "0px 10px 25px rgba(255, 127, 0, 0.7)",
                transform: "translateY(-3px)",
              },
            }}
            onClick={handleAttendOpen}
          >
            Visitor
          </Button>
        </Box>
      </Box>


      {/* Popup Modal */}
      <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { borderRadius: "15px", padding: "1.5rem", maxWidth: "500px", width: "90%" } }}>
  <IconButton onClick={handleClose} sx={{ position: "absolute", top: "10px", right: "10px", color: "#FF7F00" }}>
    <CloseIcon />
  </IconButton>
  <DialogTitle sx={{ textAlign: "center", color: "#FF7F00", fontSize: { xs: "1.2rem", md: "1.5rem" } }}>
    Select Your Role
  </DialogTitle>
  <DialogContent sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, justifyContent: "center", gap: 2 }}>
    <Button
      variant="contained"
      onClick={() => navigate("/StudentRegister")}
      sx={{ backgroundColor: "#FF7F00", color: "white", width: "100%" }}
    >
      Students & Budding Entrepreneurs
    </Button>
    <Button
      variant="outlined"
      onClick={() => navigate("/invesRegis")}
      sx={{ borderColor: "#FF7F00", color: "#FF7F00", width: "100%" }}
    >
      Angel Investors & Mentors
    </Button>
    <Button
      variant="contained"
      onClick={() => navigate("/StartupRegister")}
      sx={{ backgroundColor: "#FF7F00", color: "white", width: "100%" }}
    >
      Startup Registration
    </Button>
  </DialogContent>
</Dialog>
    <Dialog open={attendOpen} onClose={handleAttendClose} PaperProps={{ sx: { borderRadius: "15px", padding: "1.5rem", maxWidth: "500px" } }}>
        <IconButton onClick={handleAttendClose} sx={{ position: "absolute", top: "10px", right: "10px", color: "#FF7F00" }}>
          <CloseIcon />
        </IconButton>
        <DialogTitle sx={{ textAlign: "center", color: "#FF7F00" }}>Visit The Event</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            variant="outlined"
          />
          <TextField
            fullWidth
            margin="dense"
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            variant="outlined"
          />
          <TextField
            fullWidth
            margin="dense"
            label="Contact Number"
            name="phone_number"
            value={formData.phone_number}
            onChange={handleChange}
            variant="outlined"
          />
          <Button
            variant="contained"
            sx={{
              mt: 2,
              backgroundColor: "#FF7F00",
              color: "white",
              fontSize: "1.2rem",
              padding: "12px 24px",
              "&:hover": {
                backgroundColor: "white",
                color: "#FF7F00",
              },
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </DialogContent>
      </Dialog>
      <motion.div

        initial={{ opacity: 0 }}

        animate={{ opacity: 1 }}

        transition={{ delay: 2.5, duration: 1 }}

        style={{

          position: "absolute",

          bottom: "30px",

          left: "50%",

          transform: "translateX(-50%)",

        }}

      >

        <motion.div animate={{ y: [0, 10, 0] }} transition={{ repeat: Number.POSITIVE_INFINITY, duration: 1.5 }}>

          <Typography

            variant="body2"

            sx={{

              color: "white",

              textAlign: "center",

              textShadow: "1px 1px 3px rgba(0,0,0,0.5)",

            }}

          >

            Scroll Down

          </Typography>

          <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>

            <Box

              sx={{

                width: "30px",

                height: "50px",

                border: "2px solid white",

                borderRadius: "20px",

                position: "relative",

                "&::before": {

                  content: '""',

                  position: "absolute",

                  top: "8px",

                  left: "50%",

                  width: "6px",

                  height: "6px",

                  backgroundColor: "white",

                  borderRadius: "50%",

                  transform: "translateX(-50%)",

                  animation: "scrollDown 1.5s infinite",

                },

                "@keyframes scrollDown": {

                  "0%": { top: "8px", opacity: 1 },

                  "100%": { top: "32px", opacity: 0 },

                },

              }}

            />

          </Box>

        </motion.div>

      </motion.div>

    </Box>
  );
}

const AboutSection = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleAttendOpen = () => setAttendOpen(true);
  const handleAttendClose = () => setAttendOpen(false);
  const handleClose = () => setOpen(false);
  const [attendOpen, setAttendOpen] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", phone_number: "" });


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const { name, email, phone_number } = formData;
  
    if (!name || !email || !phone_number) {
      Swal.fire("Error", "All fields are required.", "error");
      return;
    }
  
    const payload = {
      ...formData,
      message: "I am visiting the event",
    };
  
    try {
      const response = await axios.post(
        "https://puneexpobackend.tdtlworld.com/contact/attend/",
        payload
      );
      if (response.status === 201) {
        Swal.fire("Success", "Attendance accepted successfully!", "success");
        handleAttendClose();
        setFormData({ name: "", email: "", phone_number: "" });
      }
    } catch (error) {
      Swal.fire("Error", "Please check network and required fields", "error");
    }
  };
  

  return (
    <Box
      id="about"
      sx={{
        py: { xs: 8, md: 12 },
        px: { xs: 2, sm: 4, md: 6 },
        backgroundColor: "#f8f8f8",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "center",
            p: { xs: 3, md: 5 },
            backgroundColor: "#fff",
            borderRadius: "20px",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
            overflow: "hidden",
          }}
        >
          {/* Text Content Section */}
          <motion.div
            initial={{ x: isMobile ? 0 : 100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8 }}
            style={{
              flex: 1,
              padding: isMobile ? "1rem" : "2rem",
              order: isMobile ? 2 : 1,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                color: "red",
                textTransform: "uppercase",
                letterSpacing: "1px",
                fontSize: { xs: "1.5rem", sm: "2rem", md: "2.25rem" },
              }}
            >
              Pune Startup Expo 2025
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 3,
                mb: 2,
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "rgba(255, 0, 0, 0.1)",
                  p: 1,
                  borderRadius: "8px",
                  mr: 2,
                }}
              >
                <CalendarTodayIcon sx={{ color: "red", mr: 1 }} />
                <Typography variant="body2" sx={{ fontWeight: "600", color: "#333" }}>
                  April 10th, 2025
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "rgba(255, 0, 0, 0.1)",
                  p: 1,
                  borderRadius: "8px",
                }}
              >
                <LocationOnIcon sx={{ color: "red", mr: 1 }} />
                <Typography variant="body2" sx={{ fontWeight: "600", color: "#333" }}>
                  MIT WPU, Pune
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "rgba(255, 0, 0, 0.1)",
                  p: 1,
                  borderRadius: "8px",
                }}
              >
                <AccessTimeIcon  sx={{ color: "red", mr: 1 }} />
                <Typography variant="body2" sx={{ fontWeight: "600", color: "#333" }}>
                  Time :  9:00 AM - 6:00 PM
                </Typography>
              </Box>
            </Box>

            <Typography
              variant="body1"
              sx={{
                mt: 3,
                lineHeight: 1.8,
                color: "#555",
              }}
            >
              Join us for Pune's <b> startup expo</b>! This is the ultimate platform to showcase your startup,
              connect with investors, and gain valuable insights from industry leaders.
            </Typography>

            {/* Extra Details to Fill Space */}
            <Typography
              variant="body1"
              sx={{
                mt: 3,
                lineHeight: 1.8,
                color: "#555",
                fontWeight: "bold",
              }}
            >
              🔹 Why Attend?
            </Typography>

            <Grid container spacing={2} sx={{ mt: 1 }}>
              {[
                { icon: "🚀", text: "Network with 1000+ professionals & investors" },
                { icon: "🎤", text: "Expert mentorship from industry leaders" },
                { icon: "🏆", text: "Exclusive awards & startup showcase opportunities" },
                { icon: "📈", text: "Potential investment & funding discussions" },
                { icon: "📌", text: "Workshops on business growth & branding" },
              ].map((item, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        p: 1.5,
                        backgroundColor: "rgba(255, 152, 0, 0.1)",
                        borderRadius: "10px",
                        height: "100%",
                        alignItems: "center",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          backgroundColor: "rgba(255, 152, 0, 0.2)",
                          transform: "translateY(-5px)",
                          boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                        },
                      }}
                    >
                      <Typography variant="h6" sx={{ mr: 1 }}>
                        {item.icon}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#555", fontWeight: "medium" }}>
                        {item.text}
                      </Typography>
                    </Box>
                  </motion.div>
                </Grid>
              ))}
            </Grid>

            {/* Call-to-Action Buttons */}
            <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        mt: 4,
        justifyContent: { xs: "center", sm: "flex-start" },
      }}
    >
      {/* Register Button */}
      <motion.div
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, delay: 1.2 }}
        whileHover={{ scale: 1.1 }}
      >
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#FF7F00",
            color: "white",
            borderRadius: "30px",
            boxShadow: "0px 5px 15px rgba(255, 127, 0, 0.5)",
            fontSize: "1.2rem",
            padding: "12px 24px",
            "&:hover": {
              backgroundColor: "white",
              color: "#FF7F00",
              boxShadow: "0px 10px 25px rgba(255, 127, 0, 0.7)",
              transform: "translateY(-3px)",
            },
          }}
          onClick={handleOpen}
        >
          Participate Now
        </Button>
      </motion.div>

      {/* Attend Button */}
      <motion.div
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, delay: 1.5 }}
        whileHover={{ scale: 1.1 }}
      >
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#FF7F00",
            color: "white",
            borderRadius: "30px",
            boxShadow: "0px 5px 15px rgba(255, 127, 0, 0.5)",
            fontSize: "1.2rem",
            padding: "12px 24px",
            "&:hover": {
              backgroundColor: "white",
              color: "#FF7F00",
              boxShadow: "0px 10px 25px rgba(255, 127, 0, 0.7)",
              transform: "translateY(-3px)",
            },
          }}
          onClick={handleAttendOpen}
        >
          Visitor
        </Button>
      </motion.div>

      {/* Register Popup Modal */}
      <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { borderRadius: "15px", padding: "1.5rem", maxWidth: "500px", width: "90%" } }}>
  <IconButton onClick={handleClose} sx={{ position: "absolute", top: "10px", right: "10px", color: "#FF7F00" }}>
    <CloseIcon />
  </IconButton>
  <DialogTitle sx={{ textAlign: "center", color: "#FF7F00", fontSize: { xs: "1.2rem", md: "1.5rem" } }}>
    Select Your Role
  </DialogTitle>
  <DialogContent sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, justifyContent: "center", gap: 2 }}>
    <Button
      variant="contained"
      onClick={() => navigate("/StudentRegister")}
      sx={{ backgroundColor: "#FF7F00", color: "white", width: "100%" }}
    >
      Students & Budding Entrepreneurs
    </Button>
    <Button
      variant="outlined"
      onClick={() => navigate("/invesRegis")}
      sx={{ borderColor: "#FF7F00", color: "#FF7F00", width: "100%" }}
    >
      Angel Investors & Mentors
    </Button>
    <Button
      variant="contained"
      onClick={() => navigate("/StartupRegister")}
      sx={{ backgroundColor: "#FF7F00", color: "white", width: "100%" }}
    >
      Startup Registration
    </Button>
  </DialogContent>
</Dialog>

      {/* Attend Popup Modal */}
      <Dialog open={attendOpen} onClose={handleAttendClose} PaperProps={{ sx: { borderRadius: "15px", padding: "1.5rem", maxWidth: "500px" } }}>
        <IconButton onClick={handleAttendClose} sx={{ position: "absolute", top: "10px", right: "10px", color: "#FF7F00" }}>
          <CloseIcon />
        </IconButton>
        <DialogTitle sx={{ textAlign: "center", color: "#FF7F00" }}>Visit The Event</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            variant="outlined"
          />
          <TextField
            fullWidth
            margin="dense"
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            variant="outlined"
          />
          <TextField
            fullWidth
            margin="dense"
            label="Contact Number"
            name="phone_number"
            value={formData.phone_number}
            onChange={handleChange}
            variant="outlined"
          />
          <Button
            variant="contained"
            sx={{
              mt: 2,
              backgroundColor: "#FF7F00",
              color: "white",
              fontSize: "1.2rem",
              padding: "12px 24px",
              "&:hover": {
                backgroundColor: "white",
                color: "#FF7F00",
              },
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </DialogContent>
      </Dialog>
    </Box>
          </motion.div>

          {/* Image Section */}
          <motion.div
  initial={{ x: isMobile ? 0 : -100, opacity: 0 }}
  whileInView={{ x: 0, opacity: 1 }}
  viewport={{ once: true, amount: 0.3 }}
  transition={{ duration: 0.8 }}
  style={{
    flex: 1,
    order: isMobile ? 1 : 2,
    marginBottom: isMobile ? "2rem" : 0,
  }}
>
  <Card
    sx={{
      position: "relative",
      borderRadius: "16px",
      boxShadow: "0 6px 25px rgba(0, 0, 0, 0.3)",
      overflow: "hidden",
      transition: "transform 0.5s",
      '&:hover': {
        transform: "scale(1.05)",
      },
    }}
  >
    <CardMedia
      component="img"
      image={dada || "/placeholder.svg"}
      alt="Pune Startup Expo 2025"
      sx={{
        width: "100%",
        position: "relative",
        zIndex: 1,
      }}
    />
    <CardContent sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        Hon. Shree Chandrakant Dada Patil
      </Typography>
      <Typography variant="subtitle1">
        Minister of Higher and Technical Education Govt of Maharashtra
      </Typography>
    </CardContent>
  </Card>
</motion.div>


        </Box>
      </Container>
    </Box>
  )
}

const startups = [
  { id: 1, name: "Tech Visionaries", desc: "AI-powered solutions for tomorrow's challenges" },
  { id: 2, name: "InnovateX", desc: "Revolutionizing healthcare with blockchain technology" },
  { id: 3, name: "Futurify", desc: "Smart home automation for sustainable living" },
  { id: 4, name: "NexGen Solutions", desc: "Enterprise software for the digital transformation era" },
  { id: 5, name: "RevolutionAI", desc: "Machine learning algorithms for predictive analytics" },
  { id: 6, name: "EcoTech", desc: "Green technology solutions for a sustainable future" },
]

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
}

const Industries = () => {
  const industries = [
    { id: 1, name: "AI & ML", desc: "Pioneering advancements in artificial intelligence & machine learning.", image: "data:image/jpeg;base64,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" },
    { id: 2, name: "Fashion", desc: "Innovating the future of fashion with cutting-edge designs.", image: "data:image/jpeg;base64,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" },
    { id: 3, name: "Agriculture and food", desc: "Revolutionizing agriculture with advanced fertilizers.", image: "https://static.vecteezy.com/system/resources/thumbnails/008/946/406/small_2x/people-are-watering-and-fertilizing-the-plants-environmental-care-concept-photo.jpg" },
    {
      id: 2,
      name: "Entertainment & Media",
      desc: "Innovative solutions revolutionizing the entertainment & media landscape.", image:"https://www.e-spincorp.com/wp-content/uploads/2019/01/Media-Entertainment-1024x512.jpg"},
    { id: 5, name: "Real Estate", desc: "Transforming urban landscapes with innovative infrastructure.", image: "https://thumbs.dreamstime.com/b/architect-civil-engineer-holding-laptop-inspect-oversee-infrastructure-progress-security-city-construction-project-207314083.jpg" },
    { id: 6, name: "Healthcare and Biotech", desc: "Advancing biological sciences for a healthier tomorrow.", image: "https://images.pexels.com/photos/3938023/pexels-photo-3938023.jpeg?cs=srgb&dl=pexels-chokniti-khongchum-1197604-3938023.jpg&fm=jpg" },
  ]

  return (
    <Box
      id="industries"
      sx={{ py: { xs: 8, md: 12 }, px: { xs: 2, sm: 4, md: 6 }, backgroundColor: "#fff" }}
    >
      <Container maxWidth="xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "orange",
              mb: 2,
              textAlign: "center",
              position: "relative",
              display: "inline-block",
              left: "50%",
              transform: "translateX(-50%)",
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: "-10px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "80px",
                height: "4px",
                backgroundColor: "orange",
                borderRadius: "2px",
              },
            }}
          >
              Industries
          </Typography>

          <Typography
            variant="body1"
            sx={{ textAlign: "center", maxWidth: "800px", mx: "auto", mt: 4, mb: 6, color: "#555" }}
          >
            Explore the industries driving innovation and transforming our world. From AI to Biotech, these fields are shaping the future.
          </Typography>
        </motion.div>

        <Grid container spacing={4}>
          {industries.map((industry, index) => (
            <Grid item xs={12} sm={6} md={4} key={industry.id}>
              <motion.div
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.98 }}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                transition={{ delay: index * 0.1 }}
              >
                <Card
                  sx={{
                    borderRadius: "16px",
                    overflow: "hidden",
                    backgroundColor: "#1E1E1E",
                    border: "1px solid orange",
                    height: "100%",
                    transition: "all 0.3s ease",
                    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
                    "&:hover": {
                      boxShadow: "0 15px 35px rgba(255, 165, 0, 0.3)",
                    },
                  }}
                >
                  <CardMedia
                    component="img"
                    height="220"
                    image={industry.image}
                    alt={industry.name}
                    sx={{ filter: "brightness(80%)" }}
                  />
                  <CardContent sx={{ p: 3 }}>
                    <Typography variant="h6" sx={{ fontWeight: "bold", color: "orange", mb: 1 }}>
                      {industry.name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#CCCCCC", mb: 2 }}>
                      {industry.desc}
                    </Typography>
                    
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>

        {/* <Box sx={{ textAlign: "center", mt: 6 }}>
          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "orange",
                color: "white",
                fontSize: "1rem",
                padding: "0.75rem 2rem",
                borderRadius: "30px",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#e67e00",
                  boxShadow: "0 5px 15px rgba(255, 152, 0, 0.4)",
                },
                transition: "all 0.3s ease",
              }}
            >
              View All Industries
            </Button>
          </motion.div>
        </Box> */}
      </Container>
    </Box>
  )
}
const AwardsPrizesSection = () => {
  const theme = useTheme();

  const awards = [
    {
      title: "🏆 Best Startup Idea",
      description: "Special awards and prizes for the most innovative and impactful startup ideas.",
      img: one,
    },
    {
      title: "🎓 Student Startup Award",
      description: "Honoring the best student-driven startup projects with prestigious awards.",
      img: two,
    },
    {
      title: "📜 Participation Certificate",
      description: "Every participant receives a certificate to celebrate their entrepreneurial journey.",
      img: three,
    },
  ];

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5, ease: "easeOut" } },
  };

  return (
    <Box
      id="awards"
      sx={{
        py: { xs: 8, md: 12 },
        px: { xs: 2, sm: 4, md: 6 },
        backgroundColor: "#1A1A1A",
        color: "white",
      }}
    >
      <Container maxWidth="xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#FFD700",
              textAlign: "center",
              position: "relative",
              left: "50%",
              transform: "translateX(-50%)",
              display: "inline-block",
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: "-10px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "80px",
                height: "4px",
                backgroundColor: "#FFD700",
                borderRadius: "2px",
              },
            }}
          >
            🏅 Awards & Prizes
          </Typography>

          <Typography
            variant="body1"
            sx={{ textAlign: "center", maxWidth: "800px", mx: "auto", mt: 4, mb: 6, color: "#aaa" }}
          >
            Celebrate innovation and dedication! Explore the prestigious awards and special recognitions for participants.
          </Typography>
        </motion.div>

        <Grid container spacing={4} justifyContent="center">
          {awards.map((award, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                variants={cardVariants}
                whileHover={{ scale: 1.05 }}
                transition={{ delay: index * 0.2 }}
              >
                <Box
                  sx={{
                    textAlign: "center",
                    p: 3,
                    borderRadius: "16px",
                    backgroundColor: "rgba(255, 255, 255, 0.05)",
                    height: "100%",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      transform: "translateY(-10px)",
                      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
                    },
                  }}
                >
                  <Avatar
                    src={award.img}
                    alt={award.title}
                    sx={{
                      width: { xs: 120, md: 150 },
                      height: { xs: 120, md: 150 },
                      margin: "0 auto",
                      mb: 2,
                      border: "3px solid #FFD700",
                      boxShadow: "0px 0px 15px rgba(255,215,0,0.6)",
                    }}
                  />
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", color: "#FFD700", textShadow: "1px 1px 5px rgba(0,0,0,0.5)", mb: 1 }}
                  >
                    {award.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#CCCCCC", textShadow: "1px 1px 3px rgba(0,0,0,0.3)" }}
                  >
                    {award.description}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
const SpeakersSection = () => {
  // const theme = useTheme()
  // const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  // const speakers = [
  //   // {
  //   //   name: "Hon. Shree Chandrakant Dada Patil",
  //   //   title: "Minister of Higher and Technical Education Govt of Maharashtra",
  //   //   img: image1,
  //   // },
  //   // { name: "Mandar Deogaonkar", title: "Director, Jaisons", img: image2 },
  //   // { name: "Amruta Deogaonkar", title: "Director, Deogaonkar Foundation", img: image3 },
  //   // { name: "Dr. Amit Andre", title: "CEO, The Data Tech Labs", img: image4 },
  // ]

  // const avatarVariants = {
  //   hidden: { opacity: 0, scale: 0.5 },
  //   visible: { opacity: 1, scale: 1, transition: { duration: 0.5, ease: "easeOut" } },
  // }

  // return (
  //   <Box
  //     id="speakers"
  //     sx={{
  //       py: { xs: 8, md: 12 },
  //       px: { xs: 2, sm: 4, md: 6 },
  //       backgroundColor: "#121212",
  //       color: "white",
  //     }}
  //   >
  //     <Container maxWidth="xl">
  //       <motion.div
  //         initial={{ opacity: 0, y: 20 }}
  //         whileInView={{ opacity: 1, y: 0 }}
  //         viewport={{ once: true }}
  //         transition={{ duration: 0.8 }}
  //       >
  //         <Typography
  //           variant="h4"
  //           sx={{
  //             fontWeight: "bold",
  //             color: "orange",
  //             textAlign: "center",
  //             position: "relative",
  //             display: "inline-block",
  //             left: "50%",
  //             transform: "translateX(-50%)",
  //             "&::after": {
  //               content: '""',
  //               position: "absolute",
  //               bottom: "-10px",
  //               left: "50%",
  //               transform: "translateX(-50%)",
  //               width: "80px",
  //               height: "4px",
  //               backgroundColor: "orange",
  //               borderRadius: "2px",
  //             },
  //           }}
  //         >
  //           🎤 Meet Our Speakers
  //         </Typography>

  //         <Typography
  //           variant="body1"
  //           sx={{
  //             textAlign: "center",
  //             maxWidth: "800px",
  //             mx: "auto",
  //             mt: 4,
  //             mb: 6,
  //             color: "#aaa",
  //           }}
  //         >
  //           Learn from the best minds in the industry. Our speakers bring years of experience and insights to help you
  //           navigate the startup ecosystem.
  //         </Typography>
  //       </motion.div>

  //       <Grid container spacing={4} justifyContent="center">
  //         {speakers.map((speaker, index) => (
  //           <Grid item xs={12} sm={6} md={3} key={index}>
  //             <motion.div
  //               initial="hidden"
  //               whileInView="visible"
  //               viewport={{ once: true, amount: 0.2 }}
  //               variants={avatarVariants}
  //               whileHover={{ scale: 1.05 }}
  //               transition={{ delay: index * 0.2 }}
  //             >
  //               <Box
  //                 sx={{
  //                   textAlign: "center",
  //                   p: 3,
  //                   borderRadius: "16px",
  //                   backgroundColor: "rgba(255, 255, 255, 0.05)",
  //                   height: "100%",
  //                   transition: "all 0.3s ease",
  //                   "&:hover": {
  //                     backgroundColor: "rgba(255, 255, 255, 0.1)",
  //                     transform: "translateY(-10px)",
  //                     boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
  //                   },
  //                 }}
  //               >
  //                 <Avatar
  //                   src={speaker.img}
  //                   alt={speaker.name}
  //                   sx={{
  //                     width: { xs: 120, md: 150 },
  //                     height: { xs: 120, md: 150 },
  //                     margin: "0 auto",
  //                     mb: 2,
  //                     border: "3px solid orange",
  //                     boxShadow: "0px 0px 15px rgba(255,165,0,0.6)",
  //                   }}
  //                 />
  //                 <Typography
  //                   variant="h6"
  //                   sx={{
  //                     fontWeight: "bold",
  //                     color: "orange",
  //                     textShadow: "1px 1px 5px rgba(0,0,0,0.5)",
  //                     mb: 1,
  //                   }}
  //                 >
  //                   {speaker.name}
  //                 </Typography>
  //                 <Typography
  //                   variant="body2"
  //                   sx={{
  //                     color: "#CCCCCC",
  //                     textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
  //                   }}
  //                 >
  //                   {speaker.title}
  //                 </Typography>
  //               </Box>
  //             </motion.div>
  //           </Grid>
  //         ))}
  //       </Grid>

  //       {/* <Box sx={{ textAlign: "center", mt: 6 }}>
  //         <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
  //           <Button
  //             variant="contained"
  //             sx={{
  //               backgroundColor: "orange",
  //               color: "white",
  //               fontSize: "1rem",
  //               padding: "0.75rem 2rem",
  //               borderRadius: "30px",
  //               fontWeight: "bold",
  //               "&:hover": {
  //                 backgroundColor: "#e67e00",
  //                 boxShadow: "0 5px 15px rgba(255, 152, 0, 0.4)",
  //               },
  //               transition: "all 0.3s ease",
  //             }}
  //           >
  //             View All Speakers
  //           </Button>
  //         </motion.div>
  //       </Box> */}
  //     </Container>
  //   </Box>
  // )

  const glowAnimation = keyframes`
  0% { text-shadow: 0 0 5px orange, 0 0 10px orange; }
  50% { text-shadow: 0 0 15px orange, 0 0 30px orange; }
  100% { text-shadow: 0 0 5px orange, 0 0 10px orange; }
`

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  const speakers = [
    // Add your speaker details here
  ]

  const avatarVariants = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5, ease: "easeOut" } },
  }

  return (
    <Box
      id="speakers"
      sx={{
        py: { xs: 8, md: 12 },
        px: { xs: 2, sm: 4, md: 6 },
        backgroundColor: "#121212",
        color: "white",
      }}
    >
      <Container maxWidth="xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "orange",
              textAlign: "center",
              position: "relative",
              display: "inline-block",
              left: "50%",
              transform: "translateX(-50%)",
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: "-10px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "80px",
                height: "4px",
                backgroundColor: "orange",
                borderRadius: "2px",
              },
            }}
          >
            🎤 Meet Our Speakers
          </Typography>

          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
              maxWidth: "800px",
              mx: "auto",
              mt: 4,
              color: "#aaa",
            }}
          >
            Learn from the best minds in the industry. Our speakers bring years of experience and insights to help you
            navigate the startup ecosystem.
          </Typography>

          {/* Coming Soon Animation */}
          <Typography
            variant="h5"
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              color: "orange",
              mt: 2,
              animation: `${glowAnimation} 2s infinite alternate`,
            }}
          >
            Coming soon ......
          </Typography>
        </motion.div>

        <Grid container spacing={4} justifyContent="center">
          {speakers.map((speaker, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                variants={avatarVariants}
                whileHover={{ scale: 1.05 }}
                transition={{ delay: index * 0.2 }}
              >
                <Box
                  sx={{
                    textAlign: "center",
                    p: 3,
                    borderRadius: "16px",
                    backgroundColor: "rgba(255, 255, 255, 0.05)",
                    height: "100%",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      transform: "translateY(-10px)",
                      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
                    },
                  }}
                >
                  <Avatar
                    src={speaker.img}
                    alt={speaker.name}
                    sx={{
                      width: { xs: 120, md: 150 },
                      height: { xs: 120, md: 150 },
                      margin: "0 auto",
                      mb: 2,
                      border: "3px solid orange",
                      boxShadow: "0px 0px 15px rgba(255,165,0,0.6)",
                    }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      color: "orange",
                      textShadow: "1px 1px 5px rgba(0,0,0,0.5)",
                      mb: 1,
                    }}
                  >
                    {speaker.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#CCCCCC",
                      textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
                    }}
                  >
                    {speaker.title}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}


const TeamSection = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
 
  const speakers = [
    { name: "Mandar Deogaonkar", title: "Director, Jaisons", img: image2 },
    { name: "Amruta Deogaonkar", title: "Director, Deogaonkar Foundation", img: image3 },
    { name: "Dr. Amit Andre", title: "CEO, The Data Tech Labs", img: image4 },
    { name: "Dr. Prashant Iyer", title: "Asst Director Startup Accelerator MIT WPU", img: image11 },
    { name: "Parag Khanvilkar", title: "Senior Manager Events ", img: image14 },

    { name: "CA Sarvesh Mehendale", title: "Company name - Skyp and Co LLP , CA firm ( Partner )", img: image12 },
    { name: "Santosh Pardeshi", title: "Director Jbs Narayan Enterprise Dealer in Electronic Goods", img: image9 },
    
    { name: "Manasi Thakur", title: "Proprietor - MiFlowmeter Systems Pune", img: image5 },
    { name: "Amrut Shrotri", title: "Proprietor Deena Daily Care Sanitization Chemical Business", img: image7 },
    { name: "Vikas Apte", title: "Energy and Contract Management Consultant", img: image6 },
    { name: "Seema Kale", title: "Proprietor-Kamal Netra Rugnalaya and Yash Opticals", img: image8 },
   
    { name: "Deepa Badve", title: "Director strat-Edge HR Consultant and recruitment specialist", img: image10 },

    { name: "Krishna Varma", title: "Director.The Varma Pharmacy Pvt Ltd, Pune 13", img: image13 },
    { name: "Sunita Chitnis", title: "Intrinsic Interiors Interior and Landscape designer ", img: image20 },
    { name: "Dr. Gargi Kanhere-Kulkarni", title: "Director at Shree Chemicals Industries Pvt Ltd", img: image25 },

    { name: "Prachi Andre", title: "Vice President The Data Tech Labs", img: image19 },
    { name: "Ashish Raut", title: "Global Business Head", img: image18 },
    { name: "Nikhil Pawar", title: "DevOp's Engineer", img: image17 },
    { name: "Harshada Kabadi", title: " Sr.Software Developer", img: image21 },
    { name: "Anant Mulay", title: "Software Developer", img: image16 },
    
    { name: "Prasad Shinde", title: "Software Developer", img: image15 },
    { name: "Atharav Desai", title: "Software Developer", img: image22 },
    { name: "Mrs. Neelima Alulkar ", title: "Director: Alulkar Food's", img: image23 },
   
  ]
 
 
  return (
    <Box
      id="teammembers"
      sx={{
        py: { xs: 8, md: 12 },
        px: { xs: 2, sm: 4, md: 6 },
        backgroundColor: "#121212",
        color: "white",
      }}
    >
      <Container maxWidth="xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "orange",
              textAlign: "center",
              position: "relative",
              display: "inline-block",
              left: "50%",
              transform: "translateX(-50%)",
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: "-10px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "80px",
                height: "4px",
                backgroundColor: "orange",
                borderRadius: "2px",
              },
            }}
          >
            Meet Our Team
          </Typography>

          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
              maxWidth: "800px",
              mx: "auto",
              mt: 4,
              mb: 6,
              color: "#aaa",
            }}
          >
            We are dedicated to making this startup program a hub for innovation, collaboration, and growth.
          </Typography>
        </motion.div>

        {/* Team Members */}
        <Grid container spacing={4} justifyContent="center">
          {speakers.map((speaker, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                whileHover={{ scale: 1.05 }}
              >
                <Box
                  sx={{
                    textAlign: "center",
                    p: 3,
                    borderRadius: "16px",
                    backgroundColor: "rgba(255, 255, 255, 0.05)",
                    height: "100%",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      transform: "translateY(-10px)",
                      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
                    },
                  }}
                >
                  <Avatar
                    src={speaker.img}
                    alt={speaker.name}
                    sx={{
                      width: { xs: 120, md: 150 },
                      height: { xs: 120, md: 150 },
                      margin: "0 auto",
                      mb: 2,
                      border: "3px solid orange",
                      boxShadow: "0px 0px 15px rgba(255,165,0,0.6)",
                    }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      color: "orange",
                      textShadow: "1px 1px 5px rgba(0,0,0,0.5)",
                      mb: 1,
                    }}
                  >
                    {speaker.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#CCCCCC",
                      textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
                    }}
                  >
                    {speaker.title}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}
 

const logos = [logo1, logo2, Logo3, Logo4,Logo5,Logo6,logo7,logo8,logo9,logo10,logo11,logo12,logo13,logo14,logo15,logo16,logo17,logo18];
const batchSize = 5;
const intervalTime = 3000; // 3 seconds

const PartnerSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + batchSize) % logos.length);
    }, intervalTime);

    return () => clearInterval(interval);
  }, []);

  const currentBatch = logos
    .concat(logos) // to handle overflow looping
    .slice(currentIndex, currentIndex + batchSize);

  return (
    <Box
      id="partners"
      sx={{
        py: { xs: 8, md: 12 },
        px: { xs: 2, sm: 4, md: 6 },
        backgroundColor: "#121212",
        color: "white",
      }}
    >
      <Container maxWidth="xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "orange",
              textAlign: "center",
              mb: 4,
              position: "relative",
              display: "inline-block",
              left: "50%",
              transform: "translateX(-50%)",
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: "-10px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "80px",
                height: "4px",
                backgroundColor: "orange",
                borderRadius: "2px",
              },
            }}
          >
            Meet Our Partners
          </Typography>
        </motion.div>

        <Card
          sx={{
            backgroundColor: "#1E1E1E",
            boxShadow: "0px 4px 20px rgba(255, 165, 0, 0.3)",
            borderRadius: "16px",
            overflow: "hidden",
            p: 2,
          }}
        >
          <CardContent>
            <Box
              sx={{
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AnimatePresence mode="wait">
                <motion.div
                  key={currentIndex}
                  initial={{ opacity: 0, x: 100 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -100 }}
                  transition={{ duration: 0.5 }}
                  style={{ display: "flex", gap: "40px" }}
                >
                  {currentBatch.map((logo, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#fff",
                        padding: "10px",
                        borderRadius: "10px",
                        boxShadow: "0px 4px 10px rgba(255, 165, 0, 0.3)",
                      }}
                    >
                      <img
                        src={logo}
                        alt={`logo-${index}`}
                        style={{
                          height: 60,
                          width: "auto",
                        }}
                      />
                    </Box>
                  ))}
                </motion.div>
              </AnimatePresence>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};
// const PartnerSection = () => {
//   return (
//     <Box
//       id="partners"
//       sx={{
//         py: { xs: 8, md: 12 },
//         px: { xs: 2, sm: 4, md: 6 },
//         backgroundColor: "#121212",
//         color: "white",
//       }}
//     >
//       <Container maxWidth="xl">
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.8 }}
//         >
//           {/* Section Heading */}
//           <Typography
//             variant="h4"
//             sx={{
//               fontWeight: "bold",
//               color: "orange",
//               textAlign: "center",
//               mb: 4,
//               position: "relative",
//               display: "inline-block",
//               left: "50%",
//               transform: "translateX(-50%)",
//               "&::after": {
//                 content: '""',
//                 position: "absolute",
//                 bottom: "-10px",
//                 left: "50%",
//                 transform: "translateX(-50%)",
//                 width: "80px",
//                 height: "4px",
//                 backgroundColor: "orange",
//                 borderRadius: "2px",
//               },
//             }}
//           >
//             Meet Our Partners
//           </Typography>
//         </motion.div>

//         {/* Logo Slider Card */}
//         <Card
//           sx={{
//             backgroundColor: "#1E1E1E",
//             boxShadow: "0px 4px 20px rgba(255, 165, 0, 0.3)",
//             borderRadius: "16px",
//             overflow: "hidden",
//             p: 2,
//           }}
//         >
//           <CardContent>
//             <Box
//               sx={{
//                 overflow: "hidden",
//                 display: "flex",
//                 alignItems: "center",
//               }}
//             >
//               <motion.div
//                 style={{
//                   display: "flex",
//                   gap: "40px",
//                 }}
//                 animate={{ x: ["100%", "-100%"] }}
//                 transition={{ repeat: Infinity, duration: 40, ease: "linear" }}
//               >
//                 {[...logos, ...logos].map((logo, index) => (
//                   <Box
//                     key={index}
//                     sx={{
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                       backgroundColor: "#fff",
//                       padding: "10px",
//                       borderRadius: "10px",
//                       boxShadow: "0px 4px 10px rgba(255, 165, 0, 0.3)",
//                     }}
//                   >
//                     <img
//                       src={logo}
//                       alt={`logo-${index}`}
//                       style={{
//                         height: 60,
//                         width: "auto",
//                       }}
//                     />
//                   </Box>
//                 ))}
//               </motion.div>
//             </Box>
//           </CardContent>
//         </Card>
//       </Container>
//     </Box>
//   );
// };



const AboutUs = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        px: { xs: 2, sm: 4, md: 6 },
        backgroundColor: "#f8f8f8",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            p: { xs: 3, md: 6 },
            backgroundColor: "#282c34",
            textAlign: "center",
            borderRadius: "12px",
            boxShadow: "0 4px 15px rgba(255,165,0,0.4)",
            color: "white",
            position: "relative",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "5px",
              background: "linear-gradient(90deg, orange, red)",
            },
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                color: "orange",
                mb: 4,
                textShadow: "1px 1px 5px rgba(0,0,0,0.5)",
              }}
            >
              About Us
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: "1rem", md: "1.2rem" },
                lineHeight: "1.6",
                maxWidth: "900px",
                margin: "auto",
                opacity: 0.9,
              }}
            >
              The Pune Startup Expo is the largest gathering of entrepreneurs, investors, and business visionaries. Our
              mission is to provide a platform for startups to showcase their innovations, connect with industry
              leaders, and accelerate their growth.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: "1rem", md: "1.2rem" },
                lineHeight: "1.6",
                maxWidth: "900px",
                margin: "auto",
                opacity: 0.9,
                mt: 3,
              }}
            >
              Join us to be part of this thriving ecosystem.
            </Typography>

            
          </motion.div>
        </Box>
      </Container>
    </Box>
  )
}

const ContactUs = () => {
  const theme = useTheme();
  const [attendOpen, setAttendOpen] = useState(false);

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const handleAttendOpen = () => setAttendOpen(true);
  const handleAttendClose = () => setAttendOpen(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    phone_number: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const { name, email, message, phone_number } = formData;
    if (!name || !email || !message || !phone_number) {
      swal("Error", "All fields are required!", "error");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      swal("Error", "Invalid email format!", "error");
      return false;
    }
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone_number)) {
      swal("Error", "Phone number must be 10 digits!", "error");
      return false;
    }
    return true;
  };
  const handleSubmit = async () => {
    const { name, email, phone_number, message } = formData;
  
    if (!name || !email || !phone_number || !message) {
      Swal.fire("Error", "All fields are required.", "error");
      return;
    }
  
    try {
      const response = await axios.post(
        "https://puneexpobackend.tdtlworld.com/contact/contactus/",
        formData
      );
      if (response.status === 201) {
        Swal.fire("Success", "Record submit!", "success");
        handleAttendClose();
        setFormData({ name: "", email: "", phone_number: "", message: "" });
      }
    } catch (error) {
      Swal.fire("Error", "Please check network and required fields", "error");
    }
  };
  
  
  

  return (
    <Box id="contact" sx={{ py: { xs: 8, md: 12 }, px: { xs: 2, sm: 4, md: 6 }, backgroundColor: "#fff" }}>
      <Container maxWidth="xl">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "orange",
              textAlign: "center",
              position: "relative",
              left: "50%",
              transform: "translateX(-50%)",
              mb: 6,
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: "-10px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "80px",
                height: "4px",
                backgroundColor: "orange",
                borderRadius: "2px",
              },
            }}
          >
            Contact Us
          </Typography>
        </motion.div>

        <Box sx={{ p: { xs: 3, md: 5 }, backgroundColor: "#FFF8DC", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.2)" }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={5}>
              <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
                <Typography variant="h5" sx={{ fontWeight: "bold", color: "#333", mb: 3 }}>
                  Get In Touch
                </Typography>

                <Typography variant="body1" sx={{ color: "#555", mb: 4 }}>
                  Have questions about the expo? Want to become a sponsor? Reach out to us and our team will get back to you as soon as possible.
                </Typography>

                <Box sx={{ mb: 3, display: "flex", alignItems: "center" }}>
                  <Box sx={{ backgroundColor: "orange", borderRadius: "50%", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", mr: 2 }}>
                    <LocationOnIcon sx={{ color: "white" }} />
                  </Box>
                  <Box>
                    <Typography variant="body1" sx={{ fontWeight: "bold", color: "#333" }}>Address</Typography>
                    <Typography variant="body2" sx={{ color: "#555" }}>MIT World Peace University, Pune, Maharashtra</Typography>
                  </Box>
                </Box>

                <Box sx={{ mb: 3, display: "flex", alignItems: "center" }}>
                  <Box sx={{ backgroundColor: "orange", borderRadius: "50%", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", mr: 2 }}>
                    <EmailIcon sx={{ color: "white" }} />
                  </Box>
                  <Box>
                    <Typography variant="body1" sx={{ fontWeight: "bold", color: "#333" }}>Email</Typography>
                    <Typography variant="body2" sx={{ color: "#555" }}>startup@punestartupexpo.com</Typography>
                  </Box>
                </Box>
              </motion.div>
            </Grid>

            <Grid item xs={12} md={7}>
              <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
                <Box sx={{ backgroundColor: "white", p: { xs: 2, md: 4 }, borderRadius: "10px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)" }}>
                  <Typography variant="h5" sx={{ fontWeight: "bold", color: "#333", mb: 3 }}>Send us a Message</Typography>

                  <Grid container spacing={2}>
                    {Object.keys(formData).map((field, index) => (
                      <Grid item xs={12} sm={field === "message" ? 12 : 6} key={index}>
                        <TextField
                          fullWidth
                          label={field.replace("_", " ").toUpperCase()}
                          name={field}
                          value={formData[field]}
                          onChange={handleChange}
                          variant="outlined"
                          margin="normal"
                        />
                      </Grid>
                    ))}
                  </Grid>

                  <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
                    <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                      <Button variant="contained" onClick={handleSubmit} sx={{ backgroundColor: "orange", color: "white", fontSize: "1rem", padding: "0.75rem 2rem", borderRadius: "30px", transition: "0.3s" }}>
                        Send Message 📧
                      </Button>
                    </motion.div>
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

const Footer = () => {
  return (
    <Box sx={{ backgroundColor: "#222", color: "white", position: "relative" }}>
      {/* Main Footer */}
      <Container maxWidth="xl">
        <Box sx={{ py: 6, px: { xs: 2, sm: 4 } }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Typography variant="h5" sx={{ fontWeight: "bold", color: "orange", mb: 3 }}>
                Pune Startup Expo
              </Typography>
              <Typography variant="body2" sx={{ color: "#aaa", mb: 3, maxWidth: "350px" }}>
                The largest gathering of entrepreneurs, investors, and business visionaries in Pune. Join us for a day
                of innovation, networking, and growth opportunities.
              </Typography>
              {/* <Box sx={{ display: "flex", gap: 2 }}>
                <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }}>
                  <IconButton sx={{ color: "orange", backgroundColor: "rgba(255,255,255,0.1)" }}>
                    <FacebookIcon />
                  </IconButton>
                </motion.div>
                <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }}>
                  <IconButton sx={{ color: "orange", backgroundColor: "rgba(255,255,255,0.1)" }}>
                    <TwitterIcon />
                  </IconButton>
                </motion.div>
                <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }}>
                  <IconButton sx={{ color: "orange", backgroundColor: "rgba(255,255,255,0.1)" }}>
                    <LinkedInIcon />
                  </IconButton>
                </motion.div>
                <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }}>
                  <IconButton sx={{ color: "orange", backgroundColor: "rgba(255,255,255,0.1)" }}>
                    <InstagramIcon />
                  </IconButton>
                </motion.div>
              </Box> */}
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="h6" sx={{ fontWeight: "bold", color: "orange", mb: 3 }}>
                Quick Links
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                {["Home", "About", "Startups",  "Contact"].map((item) => (
                  <Typography
                    key={item}
                    variant="body2"
                    sx={{
                      color: "#aaa",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        color: "orange",
                        transform: "translateX(5px)",
                      },
                    }}
                  >
                    {item}
                  </Typography>
                ))}
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="h6" sx={{ fontWeight: "bold", color: "orange", mb: 3 }}>
                Resources
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                {["FAQ", "Sponsors", "Venue", "Past Events", "Testimonials"].map((item) => (
                  <Typography
                    key={item}
                    variant="body2"
                    sx={{
                      color: "#aaa",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        color: "orange",
                        transform: "translateX(5px)",
                      },
                    }}
                  >
                    {item}
                  </Typography>
                ))}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Typography variant="h6" sx={{ fontWeight: "bold", color: "orange", mb: 3 }}>
                Subscribe to Our Newsletter
              </Typography>
              <Typography variant="body2" sx={{ color: "#aaa", mb: 3 }}>
                Stay updated with the latest news, speaker announcements, and special offers.
              </Typography>
              <Box sx={{ display: "flex", mb: 2 }}>
                <TextField
                  fullWidth
                  placeholder="Your Email Address"
                  variant="outlined"
                  size="small"
                  sx={{
                    backgroundColor: "rgba(255,255,255,0.1)",
                    borderRadius: "4px 0 0 4px",
                    "& .MuiOutlinedInput-root": {
                      color: "white",
                      "& fieldset": {
                        borderColor: "rgba(255,255,255,0.2)",
                        borderRight: "none",
                      },
                      "&:hover fieldset": {
                        borderColor: "orange",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "orange",
                      },
                    },
                  }}
                />
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "orange",
                    borderRadius: "0 4px 4px 0",
                    "&:hover": {
                      backgroundColor: "#e67e00",
                    },
                  }}
                >
                  Subscribe
                </Button>
              </Box>
              <Typography variant="body2" sx={{ color: "#777", fontSize: "0.8rem" }}>
                By subscribing, you agree to our Privacy Policy and consent to receive updates from our company.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* Copyright Footer */}
      <Box
        sx={{
          backgroundColor: "#1a1a1a",
          color: "#aaa",
          textAlign: "center",
          p: 2,
          borderTop: "1px solid #333",
        }}
      >
        <Container maxWidth="xl">
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs={12} md={6} sx={{ textAlign: { xs: "center", md: "left" } }}>
              <Typography variant="body2">
                &copy; {new Date().getFullYear()} Pune Startup Expo. All rights reserved.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} sx={{ textAlign: { xs: "center", md: "right" }, mt: { xs: 1, md: 0 } }}>
              <Typography variant="body2" sx={{ display: "inline-block", mx: 1 }}>
                Terms of Service
              </Typography>
              <Typography variant="body2" sx={{ display: "inline-block", mx: 1 }}>
                Privacy Policy
              </Typography>
              <Typography variant="body2" sx={{ display: "inline-block", mx: 1 }}>
                Cookie Policy
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Scroll to top button */}
      <ScrollToTop />
    </Box>
  )
}

// Scroll to top component
const ScrollToTop = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setVisible(true)
      } else {
        setVisible(false)
      }
    }

    window.addEventListener("scroll", toggleVisibility)
    return () => window.removeEventListener("scroll", toggleVisibility)
  }, [])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  return (
    <Zoom in={visible}>
      <Fab
        color="primary"
        size="medium"
        onClick={scrollToTop}
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20,
          backgroundColor: "orange",
          "&:hover": {
            backgroundColor: "#e67e00",
          },
        }}
      >
        <KeyboardArrowUpIcon />
      </Fab>
    </Zoom>
  )
}

const LandingPage = () => {
  return (
    <Box sx={{ overflowX: "hidden" }}>
      <Navbar />
      <HeroSection />
      <AboutSection />
      < AwardsPrizesSection/>
      <Industries />
      <TeamSection />
      
      <PartnerSection />
      <AboutUs />
      <ContactUs />
      <Footer />
    </Box>
  )
}

export default LandingPage

